import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "aa-selfserv-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  title = "selfserv";
}
